<template>
  <div>
    <v-menu
        bottom
        left
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
            icon
            v-bind="attrs"
            v-on="on"
            :style="{marginTop: '2px'}"
        >
          <v-icon small>fas fa-file-import</v-icon>
        </v-btn>
      </template>

      <v-list>
        <v-list-item @click="openExportHandler">
          <v-list-item-icon>
            <v-icon style="font-size: 18px">fas fa-upload</v-icon>
          </v-list-item-icon>
          <v-list-item-title>
            Export
          </v-list-item-title>
        </v-list-item>
        <v-list-item @click="openImportHandler">
          <v-list-item-icon>
            <v-icon style="font-size: 18px">fas fa-download</v-icon>
          </v-list-item-icon>
          <v-list-item-title>
            Import
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <!-- EXPORT -->
    <v-dialog
        v-model="showExport"
        persistent
        max-width="600px"
        @input="openExportHandler"
    >
      <v-card>
        <v-card-title class="panel-title">
          <v-icon style="font-size: 18px">fas fa-download</v-icon>
          Export
        </v-card-title>
        <v-card-text>
          <div class="alerts-container">
            <div class="alert-types">
              <div class="list-title">
                <v-icon small class="alert-icon">fas fa-dna</v-icon>
                Alert Types
              </div>
              <div
                  v-for="(typeItem, typeIndex) in types"
                  :key="`alert-type-key-${typeIndex}`"
                  class="type-item"
                  :class="selectedTypes.includes(typeItem.id) ? 'active':''"
                  @click="selectTypeHandler(typeItem.id)"
              >
                <v-icon small>
                  {{ selectedTypes.includes(typeItem.id) ? 'far fa-check-square' : 'far fa-square' }}
                </v-icon>
                {{ typeItem.name }}
              </div>
            </div>
            <div class="alert-cards">
              <div class="list-title">
                <v-icon small class="alert-icon">fas fa-credit-card</v-icon>
                Alert Cards
              </div>
              <div
                  v-for="(cardItem, cardIndex) in cards"
                  :key="`alert-card-key-${cardIndex}`"
                  class="card-item"
                  :class="selectedCards.includes(cardItem.alertStatistics.alertCardId) ? 'active':''"
                  @click="selectCardHandler(cardItem.alertStatistics.alertCardId)"
              >
                <v-icon small>
                  {{
                    selectedCards.includes(cardItem.alertStatistics.alertCardId) ? 'far fa-check-square' : 'far fa-square'
                  }}
                </v-icon>
                {{ cardItem.alertStatistics.name }}
              </div>
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn plain @click="closeExportHandler">Close</v-btn>
          <v-btn
              color="primary"
              :disabled="(((selectedTypes.length === 0) && (selectedCards.length === 0)) || (loading === true))"
              :loading="loading"
              @click="exportFileHandler"
          >
            Export
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
        v-model="showImport"
        persistent
        max-width="600px"
        @input="openImportHandler"
    >
      <v-card>
        <v-card-title class="panel-title">
          <v-icon style="font-size: 18px">fas fa-upload</v-icon>
          Import
        </v-card-title>
        <v-card-text>
          <v-file-input
              v-model="file"
              accept="json/*"
              label="File input"
              filled
              prepend-icon="fas fa-file"
              clearable
              clear-icon="fas fa-times"
              @change="onUploadFileHandler"
          ></v-file-input>
          <v-row class="import-overwrites">
            <v-checkbox
                v-model="overwriteCards"
                label="overwrite Alert Cards (by name)"
                on-icon="far fa-check-square"
                off-icon="far fa-square"
                dense
                hide-details
            />
            <v-checkbox
                v-model="overwriteTypes"
                label="overwrite Alert Types (by name)"
                on-icon="far fa-check-square"
                off-icon="far fa-square"
                dense
                hide-details
            />
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn plain @click="closeImportHandler">Close</v-btn>
          <v-btn
              color="primary"
              :loading="loading"
              :disabled="importFileString.length>0"
              @click="importFileHandler"
          >
            Import
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {TradeWatcherService} from "@/services/ApiService";
import download from "downloadjs";

export default {
  name: 'DataTransfer',
  props: {
    types: {
      type: Array,
      default: () => [],
    },
    cards: {
      type: Array,
      default: () => [],
    }
  },
  data: () => ({
    loading: false,
    showImport: false,
    showExport: false,
    selectedTypes: [],
    selectedCards: [],
    file: null,
    importFileString: '',
    overwriteCards: false,
    overwriteTypes: false,
  }),
  methods: {
    /**
     * reset the selected Cards and Types, and open the Export panel
     */
    openExportHandler() {
      this.selectedTypes = [];
      this.selectedCards = [];
      this.showExport = true;
    },
    /**
     * reset the selected Cards and Types, and close the Export panel
     */
    closeExportHandler() {
      this.selectedTypes = [];
      this.selectedCards = [];
      this.showExport = false;
    },
    /**
     * open the Import panel
     */
    openImportHandler() {
      this.showImport = true;
    },

    /**
     * close the Import panel and reset related variables
     */
    closeImportHandler() {
      this.showImport = false;
      this.file = null;
      this.overwriteCards = false;
      this.overwriteTypes = false;
    },
    /**
     * handle the Alert Type item selection
     * @param typeId {Number} - the ID of the alert type to select
     */
    selectTypeHandler(typeId) {
      if (this.selectedTypes.includes(typeId)) {
        this.selectedTypes = this.selectedTypes.filter(item => item !== typeId);
      } else {
        this.selectedTypes.push(typeId);
      }
    },
    /**
     * handle the Alert Card item selection
     * @param cardId {Number} - the ID of the alert card to select
     */
    selectCardHandler(cardId) {
      if (this.selectedCards.includes(cardId)) {
        this.selectedCards = this.selectedCards.filter(item => item !== cardId);
      } else {
        this.selectedCards.push(cardId);
      }
    },
    /**
     * execute the Export File api function with
     * the parameters corresponding to the selected alert cards and types
     * @returns {Promise<void>}
     */
    async exportFileHandler() {
      if (this.loading === true) return;
      this.loading = true;
      try {
        const requestParams = {
          alertCardIds: this.selectedCards,
          alertTypeIds: this.selectedTypes
        }
        const exportFileResponse = await TradeWatcherService.AlertCards.exportFile(requestParams);
        // console.log('exportFileResponse', exportFileResponse.headers);
        download(JSON.stringify(exportFileResponse.data), "alertsdata.json", "text/plain");
        this.loading = false;
      } catch (error) {
        console.error(error);
        this.$notifier.error("Could not export selected Alerts data");
        this.loading = false;
      }
    },
    /**
     * Handle the upload of file on the input file field
     * @param file {any} - the uploaded file
     */
    onUploadFileHandler(file) {
      // console.log('file', file);
      if (!file) return;
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          this.importFileString = JSON.parse(e.target.result);
        } catch (error) {
          // this.$emit('error', 'Failed to parse JSON.');
          console.error('Error parsing JSON!', error);
          this.$notifier.error("Could not import selected data");
        }
      };
      reader.onerror = () => {
        this.$notifier.error("Could not import selected data");
        console.error('Error reading the file.');
      };
      reader.readAsText(file);
    },
    /**
     * handle the import file upload api
     * - the parameter "fileString" is the stringified data that will be sent to the service
     * - the parameters "overwriteCards" and "overwriteTypes" specify if such cards or types already
     * exist on the database, should be overwritten by the new uploaded values or not
     * @returns {Promise<void>}
     */
    async importFileHandler() {
      try {
        const params = {
          fileString: this.importFileString,
          overwriteCards: this.overwriteCards,
          overwriteTypes: this.overwriteTypes,
        };
        await TradeWatcherService.AlertCards.importFile(params);
        this.$notifier.success('Data imported successfully');
        this.$emit('refresh');
      } catch (error) {
        console.error(error);
        this.$notifier.error("Could not upload provided data");
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.panel-title {
  border-bottom: 1px solid;
  padding: 8px 20px !important;
  box-sizing: content-box;
  margin-bottom: 16px;

  & > i {
    margin-right: 4px;
    margin-bottom: 2px;
  }
}

.alerts-container {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  column-gap: 16px;
  max-height: 512px;
  overflow-y: auto;
  padding: 8px;


  .list-title {
    font-size: 1.2em;
    text-transform: uppercase;
    font-weight: 200;
    margin-bottom: 8px;
    color: #4ABD96;

    & i {
      margin-bottom: 2px;
      margin-right: 1px;
    }
  }
}

.type-item, .card-item {
  padding: 2px 12px 2px 0;
  cursor: pointer;
  //border-left: 1px solid transparent;
  opacity: 0.8;

  & button {
    margin-bottom: 2px;
    margin-right: 2px;
  }
}

.import-overwrites {
  display: flex;
  flex-direction: column;
  padding-left: 45px;
}

.main-dark {
  .type-item, .card-item {
    &:hover {
      background-color: rgba(250, 250, 250, 0.05);
    }
  }

  .list-title, .alert-icon {
    color: #4ABD96;
  }

  .type-item.active, .card-item.active {
    background-color: rgba(250, 250, 250, 0.05);
    opacity: 1;
    font-weight: 600;
    //border-left: 1px solid #a693f3;
  }
}

.main-light {
  .type-item, .card-item {
    &:hover {
      background-color: rgba(0, 0, 0, 0.125);
    }
  }

  .list-title, .alert-icon {
    color: #1c6e59;
  }

  .type-item.active, .card-item.active {
    background-color: rgba(0, 0, 0, 0.075);
    opacity: 1;
    font-weight: 600;
    //border-left: 1px solid #a693f3;
  }
}
</style>
